import React from 'react';
import AdminMaterials from '../components/Admin/AdminMaterials';

const AdminMaterialPage = () => {
  return <AdminMaterials />;
};

export default AdminMaterialPage;